import styled from '@emotion/styled';

import { isBoldTime, getBoldTextPosition } from './outerRingUtils';

const Container = styled.div`
  position: absolute;
  left: 50%;
  right: 50%;
  top: 0;
  bottom: 0;
`;

const Label = styled.span<{ $bold: boolean; $xPos: number; $focused: boolean }>`
  display: inline-block;
  font-size: 16px;
  color: #6c7589;
  white-space: nowrap;
  padding: ${({ $focused }) => ($focused ? '4px 8px' : '4px 0px')};
  border-radius: 8px;
  font-weight: ${({ $bold }) => ($bold ? 700 : 400)};
  transform: ${({ $xPos }) => `
    ${$xPos ? 'rotate(0deg)' : 'rotate(4deg)'}
    ${!!$xPos ? `translateX(${$xPos}%)` : 'translateX(-5%)'}
    translateY(calc(-50px))
  `};
  background-color: ${({ $focused }) => ($focused ? '#FFF' : 'transparent')};
`;

type Props = {
  angle: number;
  label: string;
  focused: boolean;
};

export const TimeLabel = ({ angle, label, focused = false }: Props) => {
  const isBoldText = isBoldTime(label);
  const xPos = getBoldTextPosition(label);

  const formattedLabel = label.replace(':00', '');

  return (
    <Container style={{ transform: `rotate(${angle}deg)` }}>
      <Label $focused={focused} $xPos={xPos} $bold={isBoldText}>
        {formattedLabel}
      </Label>
    </Container>
  );
};
